import axios from 'axios'
import {
  LaundryModel,
  LaundryOperationModel,
  ResponseCRUD,
  ResponseObject,
  ResponseObjectPaginated,
} from '../model'

const BASEURL = process.env.REACT_APP_DEV_API_LAVANDERIA_URL

// OPERATION ORDER

export function getLaundryOperation(dto: LaundryOperationModel, page: number) {
  return axios.post<ResponseObjectPaginated<LaundryOperationModel[]>>(
    `${BASEURL}/order/getAllOperation/${page}`,
    dto,
  )
}
export function getLaundryOperationById(dto: string | undefined) {
  return axios.get<ResponseObject<LaundryOperationModel>>(
    `${BASEURL}/order/getInformationByIdOperation?id=${dto}`,
  )
}

export function createLaundryOperation(dto: LaundryOperationModel) {
  return axios.post<ResponseCRUD>(`${BASEURL}/order/createOrderOperation`, dto)
}

export function deleteLaundryOperation(dto: any) {
  return axios.delete<ResponseCRUD>(`${BASEURL}/order/deleteOrderOperation?id=${dto}`)
}

export function updateLaundryOperation(dto: LaundryOperationModel) {
  return axios.put<ResponseCRUD>(`${BASEURL}/order/updateOrderOperation`, dto)
}
// RECEPTION

export function createReceptionLaundryOperation(dto: any) {
  return axios.post<ResponseObjectPaginated<LaundryModel[]>>(
    `${BASEURL}/order/createReceptionOperation`,
    dto,
  )
}
export function createOutLaundryOperation(dto: any) {
  return axios.post<ResponseObjectPaginated<LaundryModel[]>>(
    `${BASEURL}/order/createOutputOperation`,
    dto,
  )
}

// RECEPTION DETAIL CLOTHE

export function getReceptionByLaundryOperation(dto: any, page: number) {
  return axios.post<ResponseObjectPaginated<LaundryOperationModel[]>>(
    `${BASEURL}/order/getReceptionOperationDetail?receptionId=${dto}&pageNumber=${page}`,
  )
}

export function createReceptionByLaundryOperation(dto: any) {
  return axios.post<ResponseCRUD>(`${BASEURL}/order/createDetailReceptionOperation`, dto)
}

export function deleteReceptionByLaundryOperation(dto: any) {
  return axios.delete<ResponseCRUD>(`${BASEURL}/order/deleteDetailReceptionOperation?id=${dto}`)
}

export function updateReceptionByLaundryOperation(dto: any) {
  return axios.post<ResponseCRUD>(`${BASEURL}/order/updateDetailReceptionOperation`, dto)
}

// WASH

export function startWashLaundryOperation(dto: any) {
  return axios.post<ResponseObjectPaginated<LaundryModel[]>>(
    `${BASEURL}/order/createProcesswashingOrderOperation`,
    dto,
  )
}
export function finishWashLaundryOperation(dto: any) {
  return axios.post<ResponseObjectPaginated<LaundryModel[]>>(
    `${BASEURL}/order/updateProcesswashingOrderOperation`,
    dto,
  )
}

// PRINT LAUNDRY OPERATION
export function getPrintOrderOperationReception(dto: any) {
  return axios.get<any>(`${BASEURL}/order/printReceptionOrderOperation?ordenOperationId=${dto}`, {
    responseType: 'arraybuffer', // Indica a Axios que esperas un arraybuffer en la respuesta
  })
}

export function getOrderOperationReception(dto: any) {
  return axios.get<any>(`${BASEURL}/order/getReceptionOrderOperationText?ordenOperationId=${dto}`)
}
export function getSendEmailOperationReception(dto: any) {
  return axios.post<ResponseCRUD>(`${BASEURL}/order/sendReceptionOrderOperation?ordenId=${dto}`)
}
export function getPrintOrderOperationOut(dto: any) {
  return axios.get<any>(`${BASEURL}/order/printOutputOrderOperation?ordenId=${dto}`, {
    responseType: 'arraybuffer', // Indica a Axios que esperas un arraybuffer en la respuesta
  })
}

export function getOrderOperationOut(dto: any) {
  return axios.get<any>(`${BASEURL}/order/getOutputOrderOperationText?ordenId=${dto}`)
}
export function getSendEmailOperationOut(dto: any) {
  return axios.post<ResponseCRUD>(`${BASEURL}/order/sendOutputOrderOperation?ordenId=${dto}`)
}

// TICKET LAUNDRY OPERATION

export function uploadMasiveTicketOperation(dto: any) {
  return axios.post<any>(`${BASEURL}/order/printSelfAdhesiveLabelReceptionMassiveOperation`, dto, {
    responseType: 'arraybuffer', // Indica a Axios que esperas un arraybuffer en la respuesta
  })
}

export function uploadTicketOperation(dto: any) {
  return axios.get<any>(
    `${BASEURL}/order/printSelfAdhesiveLabelReceptionOperation?ordenId=${dto}`,
    {
      responseType: 'arraybuffer', // Indica a Axios que esperas un arraybuffer en la respuesta
    },
  )
}
